import styled from 'styled-components';
import { Layout } from 'antd';

const { Sider } = Layout;

export const SidebarContainer = styled(Sider)`
  position: fixed !important;
  left: 0;
  top: 0;
  bottom: 0;
  height: 100vh;
  z-index: 200;

  .ant-layout-sider-trigger {
    position: fixed !important;
    bottom: 0;
    z-index: 201;
    background: #f0f0f0;
    color: #262626;
    border-top: 1px solid #d9d9d9;
  }
`;

export const Logo = styled.div`
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 100;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: #f9f9f9;
  }
`;

export const LogoImage = styled.img<{ collapsed: boolean }>`
  height: ${props => props.collapsed ? '60px' : '80px'};
  width: auto;
  transition: all 0.2s ease;
  object-fit: contain;
  max-width: ${props => props.collapsed ? '60px' : '200px'};
`;

export const MenuContainer = styled.div`
  height: calc(100vh - 64px);
  overflow-y: auto;
  background: #fff;
  
  /* Masquer la scrollbar mais garder le scroll */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  
  &::-webkit-scrollbar { /* WebKit */
    width: 0;
    height: 0;
  }
`;